import { Longhand } from "../longhand.js";
import Base, { compute } from "./border-top-width.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-inline-end-width}
 * @internal
 */
export default Longhand.extend(Base, {
    compute: (borderWidth, style) => {
        const borderStyle = style.computed("border-inline-end-style");
        return compute(borderStyle, borderWidth, style);
    },
});
//# sourceMappingURL=border-inline-end-width.js.map